let slider;

// let tns;
import {tns} from 'tiny-slider';

window.silesia = window.silesia || {};
window.silesia.layout = window.silesia.layout || {};

window.silesia.layout.tinySlider = function(config) {
    return {
        config:config||{
            items: 1,
            slideBy: 'page',
            autoplay: true,
            autoplayButton:false,
            autoplayButtonOutput:false,
            controls:false,
            nav:false,
            navContainer:null,
            arrowKeys:false,
            mouseDrag:true,
            lazyload:false                
        },
    
        load:function() {
            var self = this;
    
            var conf = self.config;
    
            try {
                if(conf.container && self.$el.querySelector(conf.container)) {
                    conf.container = self.$el.querySelector(conf.container);
                } else {
                    conf.container = self.$el;
                }
            } catch(e) {
                conf.container = self.$el;
            }
    
            // if(conf.container.querySelector('.gcb-silesia-post-slider__article-list')) {
            //     conf.container = conf.container.querySelector('.gcb-silesia-post-slider__article-list')
            // }
    
            var slider = tns(conf);
        
            // var slider = tns({
            //     container: '.gcb-silesia-post-slider__article-list',
            //     items: 1,
            //     slideBy: 'page',
            //     autoplay: true,
            //     autoplayButton:false,
            //     autoplayButtonOutput:false,
            //     controls:false,
            //     controlsContainer:'.gcb-silesia-post-slider .gcb-silesia-post-slider__controls',
            //     nav:false,
            //     navContainer:'.gcb-silesia-post-slider .gcb-silesia-post-slider__nav',
            //     arrowKeys:false,
            //     mouseDrag:true,
            //     lazyload:false
            //   });   

            function indexChangedCallback(info,eventName) {
                const siblingsLength = 5;
                info.navItems && Array.from(info.navItems).forEach(function(el, k){
                    el.classList.remove('tns-nav-active-before','tns-nav-active-after');
                    if(k>=(info.index-siblingsLength) && k<info.index) {
                        el.classList.add('tns-nav-active-before');
                    } else if(k<=(info.index+siblingsLength) && k>info.index) {
                        el.classList.add('tns-nav-active-after');
                    }
                });
            }

            slider.events.on('indexChanged', indexChangedCallback);
            indexChangedCallback(slider.getInfo());

            let loadedCount = 0;
            const images = conf.container.querySelectorAll('.gcb-image-slider__thumbnail img');
            images.forEach(img => {
                img.decode().then(() => {
                    loadedCount++;
                    if (loadedCount === images.length) {
                    slider.refresh(); // slider przeliczy wysokości po zdekodowaniu obrazów
                    }
                }).catch(() => {
                    loadedCount++;
                    if (loadedCount === images.length) slider.refresh();
                });
            });
        }
    };
}



// if(document.querySelector('*[x-data-lazy*="window.silesia.layout.tinySlider"]')) {
//     // import(/* webpackChunkName: "tiny-slider" */ 'tiny-slider').then((module) => {
//     //     tns = module.tns;

//     //     for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.tinySlider"]')) {
//     //         el.setAttribute('x-init', 'load')
//     //         el.setAttribute('x-data', el.getAttribute('x-data-lazy'))
//     //         el.removeAttribute('x-data-lazy');
//     //     };
//     // });

//     for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.tinySlider"]')) {
//         el.setAttribute('x-init', 'load')
//         el.setAttribute('x-data', el.getAttribute('x-data-lazy'))
//         el.removeAttribute('x-data-lazy');
//     };
// }

window.addEventListener('load', () => {
    for(var el of document.querySelectorAll('*[x-data-lazy*="window.silesia.layout.tinySlider"]')) {
        el.setAttribute('x-init', 'load')
        el.setAttribute('x-data', el.getAttribute('x-data-lazy'))
        el.removeAttribute('x-data-lazy');
    };
  });
